module.exports = __webpack_public_path__ + "img/home-active-v2.82c60db8.svg";